<template>
  <div class="top-indent">
   <div class="tight-block">
    <a href="#" class="btn scrollToHistory">Order History</a>
    <h2 class="title mt-50">Order by Prescription Number</h2> 
    <div class="alert-text">
      <div class="icon icon-alert"></div>
      <div class="text">Please do not send new prescriptions through this page. Use <a href="/veterinarians/internal/new-prescription">New Prescription Form</a> instead. Thank you.</div>
    </div>
    <div class="alert-text">
      <div class="icon icon-alert"></div>
      <div class="text">This will be billed the card on file, and shipped to the same address as on the previous order.</div>
    </div>
  <div class="forms">
    <div class="head">
      <div class="item" :class="{'active': step === 1}">1. Clinic info</div>
      <div class="item" :class="{'active': step === 2}">2. Personal info</div>
      <div class="item" :class="{'active': step === 3}">3. Patient info</div>
    </div>
    <div class="body" v-show="step === 1">
      <form v-on:submit.prevent="nextStep(2)" class="form" novalidate>
        <!--<div class="row">
          <div class="col">
            <div class="input-wrap">
              <div class="icon icon-user"></div>
              <input
                type="text"
                id="clinic_account_number"
                v-model="refill.step1.clinic_account_number"
                name="clinic_account_number"
                placeholder="Clinic Account Number *"
                required="required"
                class="input LoNotSensitive"
                :class="{ 'error': $v.refill.step1.clinic_account_number.$error }"
                @input="$v.refill.step1.clinic_account_number.$touch()"
              />
              <label
                v-if="$v.refill.step1.clinic_account_number.$error && !$v.refill.step1.clinic_account_number.required"
                class="error"
                for="clinic_account_number"
              >This field is required.</label>
            </div>
          </div>
        </div>-->
        <div class="row">
          <div class="col">
            <div class="label">Shipping/Pickup*</div>
            <div class="select-wrap">
              <div class="icon icon-truck"></div>
              <select
                placeholder="Shipping"
                name="shipping"
                @input="$v.refill.step1.shipping.$touch()"
                v-model="refill.step1.shipping"
                class="select LoNotSensitive"
              >
                <option value="shipping">Shipping</option>
                <option value="pickup">Pickup</option>
              </select>
            </div>
            <p v-if="refill.step1.shipping == 'pickup'">(For pick-ups allow one business day.)</p>
          </div>
        </div>
        <div class="row" v-if="refill.step1.shipping == 'shipping'">
          <div class="col">
            <div class="label">Shipping Address*</div>
          </div>
        </div>
        <div class="row" v-if="refill.step1.shipping == 'shipping'">
          <div class="col">
            <div class="input-wrap">
              <div class="icon icon-location"></div>
              <input
                type="text"
                v-model="refill.step1.street"
                placeholder="Street Address"
                name="street"
                required="required"
                class="input LoNotSensitive"
                :class="{ 'error': $v.refill.step1.street.$error }"
                @input="$v.refill.step1.street.$touch()"
              />
              <label
                v-if="$v.refill.step1.street.$error && !$v.refill.step1.street.required"
                class="error"
                for="name"
              >This field is required.</label>
            </div>
          </div>
          <div class="col">
            <div class="input-wrap">
              <div class="icon icon-building"></div>
              <pattern-input
                type="text"
                name="city"
                :regExp="inputSettings.regExp"
                :replacement="inputSettings.replacement"
                v-model="refill.step1.city"
                placeholder="City"
                required="required"
                class="input LoNotSensitive"
                :class="{ 'error': $v.refill.step1.city.$error }"
                @input="$v.refill.step1.city.$touch()"
              ></pattern-input>
              <label
                v-if="$v.refill.step1.city.$error && !$v.refill.step1.city.required"
                class="error"
                for="name"
              >This field is required.</label>
            </div>
          </div>
        </div>
        <div class="row" v-if="refill.step1.shipping == 'shipping'">
          <div class="col">
            <div class="input-wrap">
              <div class="icon icon-shield"></div>
              <pattern-input
                type="text"
                name="state"
                :regExp="inputSettings.regExp"
                :replacement="inputSettings.replacement"
                v-model="refill.step1.state"
                placeholder="State / Province / Region"
                required="required"
                class="input text LoNotSensitive"
                :class="{ 'error': $v.refill.step1.state.$error }"
                @input="$v.refill.step1.state.$touch()"
              ></pattern-input>
              <label
                v-if="$v.refill.step1.state.$error && !$v.refill.step1.state.required"
                class="error"
                for="name"
              >This field is required.</label>
            </div>
          </div>
          <div class="col">
            <div class="input-wrap">
              <div class="icon icon-mail"></div>
              <input
                type="text"
                name="zip"
                v-model="refill.step1.zip"
                placeholder="Zip / Postal Code"
                required="required"
                class="input number LoNotSensitive"
                :class="{ 'error': $v.refill.step1.zip.$error }"
                @input="$v.refill.step1.zip.$touch()"
              />
              <label
                v-if="$v.refill.step1.zip.$error && !$v.refill.step1.zip.required"
                class="error"
                for="name"
              >This field is required.</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col"></div>
          <div class="col">
            <button type="submit" class="btn wide">Next</button>
          </div>
        </div>
      </form>
    </div>
    <div class="body" v-show="step === 2">
      <form v-on:submit.prevent="nextStep(3)" class="form" novalidate>
        <div class="row">
          <div class="col">
            <p>If credit card info has changed please call us at 800-481-1729.</p>
          </div>
        </div>
        <div class="row">
          <div class="col wide">
            <div class="label">Name of Person Requesting Refill</div>
          </div>
          <div class="col">
            <div class="input-wrap">
              <div class="icon icon-user"></div>
              <input
                type="text"
                v-model="refill.step2.first_name"
                placeholder="Name - First"
                name="first_name"
                required="required"
                class="input LoNotSensitive"
                :class="{ 'error': $v.refill.step2.first_name.$error }"
                @input="$v.refill.step2.first_name.$touch()"
              />
              <label
                v-if="$v.refill.step2.first_name.$error && !$v.refill.step2.first_name.required"
                class="error"
                for="name"
              >This field is required.</label>
            </div>
          </div>
          <div class="col">
            <div class="input-wrap">
              <div class="icon icon-user"></div>
              <input
                type="text"
                v-model="refill.step2.last_name"
                placeholder="Name - Last"
                name="last_name"
                required="required"
                class="input LoNotSensitive"
                :class="{ 'error': $v.refill.step2.last_name.$error }"
                @input="$v.refill.step2.last_name.$touch()"
              />
              <label
                v-if="$v.refill.step2.last_name.$error && !$v.refill.step2.last_name.required"
                class="error"
                for="name"
              >This field is required.</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="label">Please indicate if you have a credit card on file to charge:*</div>
            <div class="select-wrap">
              <div class="icon icon-card"></div>
              <select
                placeholder="YES"
                v-model="refill.step2.credit_card"
                @input="$v.refill.step2.credit_card.$touch()"
                class="select LoNotSensitive"
              >
                <option value="yes">YES</option>
                <option value="no">NO</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="label">Info where you can be contacted*</div>
            <div class="input-wrap">
              <div class="icon icon-phone"></div>
              <input
                type="text"
                v-model="refill.step2.phone"
                placeholder="Phone Number"
                name="phone"
                required="required"
                class="input LoNotSensitive"
                v-mask="'(###) ###-####'"
                :class="{ 'error': $v.refill.step2.phone.$error }"
                @input="$v.refill.step2.phone.$touch()"
              />
              <label
                v-if="$v.refill.step2.phone.$error && !$v.refill.step2.phone.required"
                class="error"
                for="name"
              >This field is required.</label>
              <label
                v-if="$v.refill.step2.phone.$error && !$v.refill.step2.phone.minLength"
                class="error"
                for="name"
              >Minimal length is 10 numbers.</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="input-wrap">
              <div class="icon icon-mail"></div>
              <input
                type="text"
                v-model="refill.step2.email"
                placeholder="Email"
                required="required"
                name="email"
                class="input LoNotSensitive"
                :class="{ 'error': $v.refill.step2.email.$error }"
                @input="$v.refill.step2.email.$touch()"
              />
              <label
                v-if="$v.refill.step2.email.$error && !$v.refill.step2.email.required"
                class="error"
                for="name"
              >This field is required.</label>
              <label
                v-if="$v.refill.step2.email.$error && !$v.refill.step2.email.email"
                class="error"
                for="name"
              >Valid email is required.</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button type="button" v-on:click="step = 1" class="btn wide">Previous</button>
          </div>
          <div class="col">
            <button type="submit" class="btn wide">Next</button>
          </div>
        </div>
      </form>
    </div>
    <div class="body" v-show="step === 3">
      <form class="form" novalidate v-on:submit.prevent="validate">
        <div class="row hide-block-wrap">
          <div class="hide-block">
            <div class="item" v-for="(drug, index) in refill.step3.drugs" :key="index">
              <div class="row">
                <div class="col">
                  <div class="input-wrap">
                    <div class="icon icon-user"></div>
                    <input
                      type="text"
                      v-model="drug.patient_first_name"
                      placeholder="Patient - First Name"
                      name="patient_first_name"
                      required="required"
                      class="input LoNotSensitive"
                      :class="{ 'error': $v.refill.step3.drugs.$each[index].patient_first_name.$error }"
                      @input="$v.refill.step3.drugs.$each[index].patient_first_name.$touch()"
                    />
                    <label
                      v-if="$v.refill.step3.drugs.$each[index].patient_first_name.$error && !$v.refill.step3.drugs.$each[index].patient_first_name.required"
                      class="error"
                      for="name"
                    >This field is required.</label>
                  </div>
                </div>
                <div class="col">
                  <div class="input-wrap">
                    <div class="icon icon-user"></div>
                    <input
                      type="text"
                      v-model="drug.patient_last_name"
                      placeholder="Patient - Last Name"
                      name="patient_last_name"
                      required="required"
                      class="input LoNotSensitive"
                      :class="{ 'error': $v.refill.step3.drugs.$each[index].patient_last_name.$error }"
                      @input="$v.refill.step3.drugs.$each[index].patient_last_name.$touch()"
                    />
                    <label
                      v-if="$v.refill.step3.drugs.$each[index].patient_last_name.$error && !$v.refill.step3.drugs.$each[index].patient_last_name.required"
                      class="error"
                      for="name"
                    >This field is required.</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="input-wrap">
                    <div class="icon icon-drugs"></div>
                    <input
                      type="text"
                      name="prescription_no"
                      v-model="drug.prescription_no"
                      placeholder="Prescription Number"
                      class="input LoNotSensitive"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="input-wrap">
                    <div class="icon icon-drugs"></div>
                    <input
                      type="text"
                      v-model.trim="drug.drug_name"
                      placeholder="Drug Name"
                      name="drug_name"
                      required="required"
                      class="input LoNotSensitive"
                      :class="{ 'error': $v.refill.step3.drugs.$each[index].drug_name.$error }"
                      @input="$v.refill.step3.drugs.$each[index].drug_name.$touch()"
                    />
                    <label
                      v-if="$v.refill.step3.drugs.$each[index].drug_name.$error && !$v.refill.step3.drugs.$each[index].drug_name.required"
                      class="error"
                      for="name"
                    >This field is required.</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="input-wrap">
                    <div class="icon icon-drugs"></div>
                    <input
                      type="text"
                      v-model="drug.drug_strength"
                      placeholder="Strength (type n/a if non-applicable)"
                      required="required"
                      name="drug_strength"
                      class="input LoNotSensitive"
                      :class="{ 'error': $v.refill.step3.drugs.$each[index].drug_strength.$error }"
                      @input="$v.refill.step3.drugs.$each[index].drug_strength.$touch()"
                    />
                    <label
                      v-if="$v.refill.step3.drugs.$each[index].drug_strength.$error && !$v.refill.step3.drugs.$each[index].drug_strength.required"
                      class="error"
                      for="name"
                    >This field is required.</label>
                  </div>
                </div>
                <div class="col">
                  <div class="input-wrap">
                    <div class="icon icon-drugs"></div>
                    <input
                      type="text"
                      v-model="drug.drug_form"
                      placeholder="Form (type n/a if non-applicable)"
                      name="drug_form"
                      required="required"
                      class="input LoNotSensitive"
                      :class="{ 'error': $v.refill.step3.drugs.$each[index].drug_form.$error }"
                      @input="$v.refill.step3.drugs.$each[index].drug_form.$touch()"
                    />
                    <label
                      v-if="$v.refill.step3.drugs.$each[index].drug_form.$error && !$v.refill.step3.drugs.$each[index].drug_form.required"
                      class="error"
                      for="name"
                    >This field is required.</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="input-wrap">
                    <div class="icon icon-meat"></div>
                    <input
                      type="text"
                      v-model="drug.drug_flavor"
                      placeholder="Desired Flavor(if applicable)"
                      name="drug_flavor"
                      required="required"
                      class="input LoNotSensitive"
                    />
                  </div>
                </div>
                <div class="col">
                  <div class="input-wrap">
                    <div class="icon icon-drugs"></div>
                    <input
                      type="text"
                      v-model="drug.drug_pack_size"
                      placeholder="Quantity/Size"
                      name="drug_size"
                      required="required"
                      class="input LoNotSensitive"
                      :class="{ 'error': $v.refill.step3.drugs.$each[index].drug_pack_size.$error }"
                      @input="$v.refill.step3.drugs.$each[index].drug_pack_size.$touch()"
                    />
                    <label
                      v-if="$v.refill.step3.drugs.$each[index].drug_pack_size.$error && !$v.refill.step3.drugs.$each[index].drug_pack_size.required"
                      class="error"
                      for="name"
                    >This field is required.</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <a v-on:click="removeDrug(index)">Remove</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <a
              href="#"
              v-on:click.prevent="addDrug"
              class="link border-gray"
            >+Click Here For Additional Refill</a>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button type="button" v-on:click="step = 2" class="btn wide">Previous</button>
          </div>
          <div class="col">
            <vue-recaptcha
              ref="recaptcha"
              size="invisible"
              :loadRecaptchaScript="true"
              :sitekey="sitekey"
              @verify="submit"
              @expired="onCaptchaExpired"
            />
            <vue-button-spinner
              type="submit"
              :is-loading="isLoading" 
              :disabled="isLoading"
              :status="status"
              class="btn wide">
              <span>Submit</span>
            </vue-button-spinner>
          </div>
        </div>

      </form>
    </div>
  </div>

  </div>
  <sweet-modal
        ref="veterinars_refill_modal"
        :blocking="true"
        :hide-close-button="true"
    >
      <div style="text-align: center;">
        <div class="modal-close-btn cross">
          <span class="icon-cross" />
        </div>
        <div class="modal-body">
          <h2 class="title">Success!</h2>
          <div class="notification-block">
            <p>You have successfully submitted your request.<br>You should receive your order within 2 business days.<br>If you have you any questions or concerns call us at <a target="_blank" href="tel:8004811729">800-481-1729</a>. </p>
            <div class="button-wrap">
              <button
                class="btn modal-close-btn"
                style="margin: 15px auto 0;"
                @click="confirmModal"
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
    </sweet-modal>
</div>
</template>

<script>
import { required, minLength, email } from "vuelidate/lib/validators";
import VueRecaptcha from "vue-recaptcha";
import VuePatternInput from 'vue-pattern-input';
import { SweetModal } from 'sweet-modal-vue'
export default {
  name: "VeterinaryRefill",
  components: {
    VueRecaptcha,
    SweetModal,
    'pattern-input': VuePatternInput,
  },
  data: () => {
    return {
      step: 1,
      refill: {
        step1: {
          city: '',
          state: '',
          shipping: "shipping"
        },
        step2: {
          credit_card: "no"
        },
        step3: {
          drugs: [{}]
        }
      },
      sitekey: process.env.RECAPTCHA_SITE_KEY,
      inputSettings: {
        regExp: /[^\D]+/gu,
        replacement: '',
      },
      isLoading: false,
			status: '',
    };
  },
  validations() {
    let rules = {
      refill: {
        step2: {
          first_name: {
            required
          },
          last_name: {
            required
          },
          email: {
            required,
            email
          },
          phone: {
            required,
            minLength: minLength(10)
          },
          credit_card: {
            required
          }
        },
        step3: {
          drugs: {
            required,
            $each: {
              patient_first_name: {
                required
              },
              patient_last_name: {
                required
              },
              drug_name: {
                required
              },
              drug_strength: {
                required
              },
              drug_form: {
                required
              },
              drug_pack_size: {
                required
              }
            }
          }
        }
      }
    };
    if (this.refill.step1.shipping == "shipping") {
      rules.refill.step1 = {
        shipping: {
          required
        },
        street: {
          required
        },
        city: {
          required
        },
        state: {
          required
        },
        zip: {
          required
        }
      };
    } else {
      rules.refill.step1 = {
        shipping: {
          required
        }
      };
    }
    return rules;
  },
  methods: {
    submit(recaptchaToken) {
      let that = this;
      if (!this.$v.$invalid) {
        this.isLoading = true
        let formData = new FormData();
        formData.append("type", "veterinary refill");
        for (var key in this.refill.step1) {
          formData.append(key, this.refill.step1[key]);
        }
        for (var key in this.refill.step2) {
          formData.append(key, this.refill.step2[key]);
        }
        formData.append("recaptcha_token", recaptchaToken);
        for (var key in this.refill.step3) {
          if (key === "drugs") {
            let drugs = JSON.stringify(this.refill.step3[key]);
            formData.append(key, drugs);
          } else {
            formData.append(key, this.refill.step3[key]);
          }
        }
        axios
          .post("/api/forms/submit", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            if (response && response.data && response.data.result === "ok") {
              //$("#success_refill_veterinarians").addClass("show");
              that.$refs.veterinars_refill_modal.open()
              this.isLoading = false
              if (Object.keys(window).indexOf("gtag") !== -1) {
                gtag("event", "sent", {
                  event_category: "form",
                  event_label: "vet-order-refills",
                  value: 1
                });
              }
              this.refill = {
                step1: {
                  city: '',
                  state: '',
                  shipping: "shipping"
                },
                step2: {
                  credit_card: "no"
                },
                step3: {
                  drugs: [{}]
                }
              };
              this.step = 1;
              this.$v.$reset()
              this.$refs.recaptcha.reset()
            } else {
              console.log(response.data.message);
              this.isLoading = false
            }
          })
          .catch(error => {
            console.log(error);
            this.isLoading = false
          });
      }
    },
    confirmModal () {
      window.location = '/veterinarians/internal/refill'
    },
    addDrug() {
      this.refill.step3.drugs.push({});
      this.refill.step3.drugs = this.refill.step3.drugs.slice();
    },
    removeDrug(id) {
      let newDrugs = this.refill.step3.drugs;
      newDrugs.splice(id, 1);
      this.refill.step3.drugs = newDrugs;
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    validate() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$refs.recaptcha.execute();
      }
    },
    nextStep(step) {
      if (step === 2) {
        this.$v.refill.step1.$touch();
        if (!this.$v.refill.step1.$invalid) {
          this.step += 1;
        }
      } else if (step === 3) {
        this.$v.refill.step2.$touch();
        if (!this.$v.refill.step2.$invalid) {
          this.step += 1;
        }
      }
    }
  }
}
</script>
